import { render, staticRenderFns } from "./AlterarVisao.vue?vue&type=template&id=039c8e1e&scoped=true&"
import script from "./AlterarVisao.vue?vue&type=script&lang=js&"
export * from "./AlterarVisao.vue?vue&type=script&lang=js&"
import style0 from "./AlterarVisao.vue?vue&type=style&index=0&id=039c8e1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c8e1e",
  null
  
)

export default component.exports